import React from 'react'
import { withData } from '../withData'
import { Progress, Card } from 'antd'
import moment from 'moment'
import { Helmet } from 'react-helmet'

const ReportCard = ({ report, title, unit = 'days' }) => (
  <Card style={{ marginTop: '10px', textAlign: 'center' }} height={400} >
    <h2>{title}</h2>
    <h3 style={{ marginBottom: '5px' }}>
      <span>{moment(report.startDate).subtract(1, unit).format('DD/MM/YYYY')} - </span>
      <span>{moment(report.startDate).format('DD/MM/YYYY')}</span>
    </h3>
    <div style={{ marginBottom: '10px' }}>ทานไป {report.taken} ครั้ง จากทั้งหมด {report.all} ครั้ง</div>
    <Progress type="dashboard" percent={Math.floor((report.taken * 100) / report.all) || 'no'} />
  </Card>
)

export const Report = ({ data }) => (
  <div style={{ padding: '15px' }}>
    <Helmet>
      <title>สรุปผลการกินยา</title>
    </Helmet>
    <h2>
      <center>สรุปผลการกินยา</center>
    </h2>
    <div>
      <ReportCard
        title="ประจำวัน"
        report={data.data.reports.daily}
        unit="days"
      />
      <ReportCard
        title="ประจำสัปดาห์"
        report={data.data.reports.weekly}
        unit="weeks"
      />
      <ReportCard
        title="ประจำเดือน"
        report={data.data.reports.monthly}
        unit="months"
      />
    </div>
    {/*<div>{JSON.stringify(data)}</div>*/}
  </div>
)

const query = `
  query {
    reports() {
      startDate,
      endDate,
      daily {
        all,
        taken
      },
      weekly {
        all,
        taken
      },
      monthly {
        all,
        taken
      }
    }
  }
`

export default withData(query)(Report)



// WEBPACK FOOTER //
// ./src/Report/Report.js